<div class="p-4 sm:p-6 space-y-6">
  <div>
    <h1 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">
      Xabar yetkazish va SMS xizmati
    </h1>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      SIM-kartali qurilmalarni va boshqa turdagi SMS xabarlarning yetkazish rejimini shu yerdan
      boshqaring. Parol tiklash kodi (OTP) doim Telegram bot orqali yuboriladi — bu sozlamaga
      bog'liq emas.
    </p>
  </div>

  <!-- Kanal rejimi -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
  >
    <h2 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">Yetkazish rejimi</h2>

    <div class="grid gap-3 sm:grid-cols-3">
      @for (option of modeOptions; track option.value) {
        <button
          type="button"
          (click)="selectMode(option.value)"
          [disabled]="modeSaving() || modeLoading()"
          class="text-left rounded-lg border p-3 transition-colors disabled:opacity-60"
          [ngClass]="
            mode() === option.value
              ? 'border-green-500 bg-green-50 dark:bg-green-900/20 dark:border-green-600'
              : 'border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800'
          "
        >
          <div class="flex items-center gap-2 mb-1">
            <div
              class="w-3.5 h-3.5 rounded-full border-2 shrink-0"
              [ngClass]="
                mode() === option.value
                  ? 'border-green-600 bg-green-600'
                  : 'border-gray-300 dark:border-gray-600'
              "
            ></div>
            <span class="text-sm font-medium text-gray-900 dark:text-gray-100">{{
              option.title
            }}</span>
          </div>
          <p class="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
            {{ option.description }}
          </p>
        </button>
      }
    </div>
  </div>

  <!-- Sinov SMS'i -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:p-5"
  >
    <h2 class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-1">Sinov SMS'i</h2>
    <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
      Parkning uchidan uchigacha ishlashini tekshiring — OTP endi SMS'ni ishlatmaydi.
    </p>

    <div class="flex flex-col sm:flex-row gap-2">
      <input
        type="text"
        [ngModel]="testPhone()"
        (ngModelChange)="testPhone.set($event); testResult.set(null)"
        placeholder="+998901234567"
        class="w-full sm:w-56 px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono"
      />
      <input
        type="text"
        [ngModel]="testText()"
        (ngModelChange)="testText.set($event); testResult.set(null)"
        placeholder="Matn (ixtiyoriy)"
        class="w-full flex-1 px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
      />
      <button
        (click)="sendTestSms()"
        [disabled]="!testPhone().trim() || testSending()"
        class="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium disabled:opacity-50 shrink-0"
      >
        <lucide-icon [img]="Send" class="w-4 h-4"></lucide-icon>
        {{ testSending() ? 'Yuborilmoqda...' : "Navbatga qo'yish" }}
      </button>
    </div>

    @if (testResult() === 'ok') {
      <p class="text-xs text-green-600 dark:text-green-400 mt-2">
        Navbatga qo'yildi — istalgan faol qurilma keyingi so'rovida oladi.
      </p>
    } @else if (testResult() === 'error') {
      <p class="text-xs text-red-600 dark:text-red-400 mt-2">{{ testError() }}</p>
    }
  </div>

  <!-- Qurilmalar -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
    <div
      class="flex items-center justify-between gap-3 px-4 sm:px-5 py-4 border-b border-gray-100 dark:border-gray-800"
    >
      <h2 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
        SMS-gateway qurilmalari
      </h2>
      <div class="flex gap-2">
        <button
          (click)="loadGateways()"
          [disabled]="loading()"
          class="p-2 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          <lucide-icon
            [img]="RefreshCw"
            class="w-4 h-4 text-gray-500"
            [class.animate-spin]="loading()"
          ></lucide-icon>
        </button>
        <button
          (click)="openCreate()"
          class="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors"
        >
          <lucide-icon [img]="Plus" class="w-4 h-4"></lucide-icon>
          <span class="hidden sm:inline">Yangi qurilma</span>
        </button>
      </div>
    </div>

    @if (loading() && gateways().length === 0) {
      <div class="flex justify-center py-16">
        <div
          class="w-8 h-8 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"
        ></div>
      </div>
    } @else if (gateways().length === 0) {
      <div class="flex flex-col items-center justify-center py-16 text-gray-400">
        <lucide-icon [img]="Smartphone" class="w-12 h-12 mb-3"></lucide-icon>
        <p class="text-sm">Hozircha qurilma yo'q</p>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400">
            <tr>
              <th class="text-left font-medium px-4 py-3">Nomi</th>
              <th class="text-left font-medium px-4 py-3">Holat</th>
              <th class="text-left font-medium px-4 py-3">Bugun</th>
              <th class="text-left font-medium px-4 py-3">Batareya</th>
              <th class="text-left font-medium px-4 py-3">Oxirgi aloqa</th>
              <th class="text-right font-medium px-4 py-3">Boshqaruv</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (gw of gateways(); track gw.id) {
              <tr>
                <td class="px-4 py-3">
                  <div class="font-medium text-gray-900 dark:text-gray-100">{{ gw.name }}</div>
                  @if (gw.simPhoneNumber) {
                    <div class="text-xs text-gray-400 font-mono">{{ gw.simPhoneNumber }}</div>
                  }
                </td>
                <td class="px-4 py-3">
                  @if (!gw.isActive) {
                    <span class="text-xs text-amber-600 dark:text-amber-400">Faol emas</span>
                  } @else if (gw.isOnline) {
                    <span
                      class="inline-flex items-center gap-1 text-xs text-green-600 dark:text-green-400"
                    >
                      <lucide-icon [img]="Wifi" class="w-3.5 h-3.5"></lucide-icon>
                      Onlayn
                    </span>
                  } @else {
                    <span class="inline-flex items-center gap-1 text-xs text-gray-400">
                      <lucide-icon [img]="WifiOff" class="w-3.5 h-3.5"></lucide-icon>
                      Oflayn
                    </span>
                  }
                </td>
                <td class="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {{ gw.sentToday }} / {{ gw.dailyLimit }}
                </td>
                <td class="px-4 py-3">
                  @if (gw.batteryLevel !== null) {
                    <span class="inline-flex items-center gap-1 text-gray-500 dark:text-gray-400">
                      <lucide-icon
                        [img]="batteryIcon(gw.batteryLevel)"
                        class="w-4 h-4"
                      ></lucide-icon>
                      {{ gw.batteryLevel }}%
                    </span>
                  } @else {
                    <span class="text-gray-300">—</span>
                  }
                </td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">
                  {{ lastSeenText(gw.lastSeenAt) }}
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center justify-end gap-1.5">
                    <button
                      (click)="openEdit(gw)"
                      class="p-1.5 rounded-lg border border-gray-200 dark:border-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                      title="Tahrirlash"
                    >
                      <lucide-icon [img]="Pencil" class="w-3.5 h-3.5"></lucide-icon>
                    </button>
                    <button
                      (click)="reconnect(gw)"
                      [disabled]="reconnectingId() === gw.id"
                      class="p-1.5 rounded-lg border border-gray-200 dark:border-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-50"
                      title="Qayta ulash"
                    >
                      <lucide-icon [img]="Link" class="w-3.5 h-3.5"></lucide-icon>
                    </button>
                    <button
                      (click)="toggleActive(gw)"
                      [disabled]="togglingId() === gw.id"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-medium transition-colors disabled:opacity-50"
                      [ngClass]="
                        gw.isActive
                          ? 'border-red-200 dark:border-red-900 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
                          : 'border-green-200 dark:border-green-900 text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-900/20'
                      "
                    >
                      <lucide-icon [img]="Power" class="w-3.5 h-3.5"></lucide-icon>
                      {{ gw.isActive ? "O'chirish" : 'Yoqish' }}
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<p-confirmDialog />

<!-- Tahrirlash oynasi -->
@if (editOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
    <div
      class="w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 shadow-xl max-h-[90vh] overflow-y-auto"
    >
      <div
        class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-800"
      >
        <h2 class="font-semibold text-gray-900 dark:text-gray-100">Qurilmani tahrirlash</h2>
        <button
          (click)="closeEdit()"
          class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          <lucide-icon [img]="X" class="w-4 h-4 text-gray-500"></lucide-icon>
        </button>
      </div>

      <div class="px-5 py-4 space-y-4">
        <div>
          <label for="" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Nomi *</label
          >
          <input
            type="text"
            [ngModel]="editName()"
            (ngModelChange)="editName.set($event)"
            placeholder="Ofis Beeline"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
          />
        </div>

        <div>
          <label for="" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Kunlik limit</label
          >
          <input
            type="number"
            [ngModel]="editDailyLimit()"
            (ngModelChange)="editDailyLimit.set($event)"
            min="1"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
          />
        </div>

        <div>
          <label for="" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >SIM raqami</label
          >
          <input
            type="text"
            [ngModel]="editSimPhoneNumber()"
            (ngModelChange)="editSimPhoneNumber.set($event)"
            placeholder="+998901234567"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono"
          />
          <p class="text-xs text-gray-400 mt-1">
            Faqat ma'lumot uchun — yuborishga ta'sir qilmaydi.
          </p>
        </div>
      </div>

      <div class="flex justify-end gap-2 px-5 py-4 border-t border-gray-100 dark:border-gray-800">
        <button
          (click)="closeEdit()"
          class="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-800 text-sm"
        >
          Bekor qilish
        </button>
        <button
          (click)="submitEdit()"
          [disabled]="!editName().trim() || editSubmitting()"
          class="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium disabled:opacity-50"
        >
          {{ editSubmitting() ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Yangi qurilma oynasi -->
@if (createOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
    <div
      class="w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 shadow-xl max-h-[90vh] overflow-y-auto"
    >
      <div
        class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-800"
      >
        <h2 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ result() ? 'Qurilmani ulash' : 'Yangi SMS-gateway' }}
        </h2>
        <button
          (click)="closeCreate()"
          class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          <lucide-icon [img]="X" class="w-4 h-4 text-gray-500"></lucide-icon>
        </button>
      </div>

      @if (!result()) {
        <!-- 1-qadam: nom va turi -->
        <div class="px-5 py-4 space-y-4">
          <div>
            <label for="" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Nomi *</label
            >
            <input
              type="text"
              [(ngModel)]="createName"
              placeholder="Ofis Beeline"
              class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
            />
          </div>

          <div>
            <label for="" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Kunlik limit
            </label>
            <input
              type="number"
              [ngModel]="createDailyLimit()"
              (ngModelChange)="createDailyLimit.set($event)"
              min="1"
              class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm"
            />
            <p class="text-xs text-gray-400 mt-1">
              Operator SIM'ni spam deb bloklab qo'ymasligi uchun
            </p>
          </div>
        </div>

        <div class="flex justify-end gap-2 px-5 py-4 border-t border-gray-100 dark:border-gray-800">
          <button
            (click)="closeCreate()"
            class="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-800 text-sm"
          >
            Bekor qilish
          </button>
          <button
            (click)="submitCreate()"
            [disabled]="!createName().trim() || createSubmitting()"
            class="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium disabled:opacity-50"
          >
            {{ createSubmitting() ? 'Yaratilmoqda...' : 'Yaratish' }}
          </button>
        </div>
      } @else {
        <!-- 2-qadam: QR kod va faollashtirish kodi -->
        <div class="px-5 py-4 space-y-4">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Telefonda <span class="font-medium">Miyzan SMS</span> ilovasini oching va QR'ni
            skanerlang, yoki kodni qo'lda kiriting. Kod 24 soat amal qiladi.
          </p>

          @if (qrDataUrl()) {
            <div class="flex justify-center">
              <img
                [src]="qrDataUrl()"
                alt="QR kod"
                class="rounded-lg border border-gray-200 dark:border-gray-800"
              />
            </div>
          }

          <div class="flex items-center justify-center gap-2">
            <span class="font-mono text-lg tracking-wider text-gray-900 dark:text-gray-100">
              {{ result()!.activationCode }}
            </span>
            <button
              (click)="copyCode()"
              class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
              title="Nusxalash"
            >
              <lucide-icon
                [img]="codeCopied() ? Check : Copy"
                class="w-4 h-4"
                [ngClass]="codeCopied() ? 'text-green-600' : 'text-gray-400'"
              ></lucide-icon>
            </button>
          </div>

          <div>
            <label for="" class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
              Server manzili (QR shunga ishora qiladi)
            </label>
            <input
              type="text"
              [ngModel]="serverUrl()"
              (ngModelChange)="serverUrl.set($event); onServerUrlChange()"
              class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 text-sm font-mono"
            />
          </div>
        </div>

        <div class="flex justify-end gap-2 px-5 py-4 border-t border-gray-100 dark:border-gray-800">
          <button
            (click)="closeCreate()"
            class="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium"
          >
            Tayyor
          </button>
        </div>
      }
    </div>
  </div>
}
